import { getImageUrl } from '../../../../utils';

export const MLP_IMAGE_URL = getImageUrl('CM20130722-53469-03363');
